import { TOKEN } from 'utils/constants/index'

/* ==========================================================================
  Auth Token
========================================================================== */
export const getAuthTokenFromSessionStorage = () => {
  return window.sessionStorage.getItem(TOKEN)
}

export const setAuthTokenInSessionStorage = (authAccessToken) => {
  window.sessionStorage.setItem(TOKEN, authAccessToken)
}

export const removeAuthTokenFromSessionStorage = () => {
  window.sessionStorage.removeItem(TOKEN)
}

/* ==========================================================================
  SignIn Action
========================================================================== */
export const signInSessionStorage = ({ token }) => {
  setAuthTokenInSessionStorage(token)
}

/* ==========================================================================
  SignOut Action
========================================================================== */
export const signOutSessionStorage = () => {
  removeAuthTokenFromSessionStorage()
}
